import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { HeaderTitle, Label } from '@atlas/ui';

import { documentShape } from 'common/PropTypes/documentShape';

import UploadDocumentItem from './UploadDocumentItem';

const UploadDocumentList = ({ documents }) => {
  const documentsList = useMemo(() => {
    if (documents.length === 0) {
      return (
        <div className="verify-not-file">
          <Label className="title-text" message="identity_not_verified" />
          <span className="sub-title-text">
            Upload documents to verify your account. After that, the manager will check and verify
            your documents and account.
          </span>
        </div>
      );
    }

    const sortedDocuments = [...documents]
      .sort((documentA, documentB) => documentA.documentUploadTime - documentB.documentUploadTime)
      .reverse();

    return (
      <div className="profile-verify__list">
        {sortedDocuments.map((document, index) => (
          <UploadDocumentItem document={document} key={index} />
        ))}
      </div>
    );
  }, [documents]);

  return (
    <div className="verify">
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium border" title="uploaded_documents" />
      </div>
      {documentsList}
    </div>
  );
};

UploadDocumentList.propTypes = { documents: PropTypes.arrayOf(documentShape).isRequired };

export default UploadDocumentList;
